import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService, CommonService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { InCompleteReport, Store, AppState } from '../../../../store';

@Component({
  selector: 'app-incomplete-report',
  templateUrl: './incomplete-report.component.html',
  styleUrls: ['./incomplete-report.component.css']
})
export class IncompleteReportComponent extends ReportBase implements OnInit {

  @Output() rcheck = new EventEmitter();

  report: InCompleteReport;
  controls = [
    // { name: 'avatar', type: 'text', title: 'Avatar' },
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'dateRegistered', type: 'date', title: 'Date' },
    { name: 'teamGroup', type: 'text', title: 'Team' },
    { name: 'gender', type: 'select', title: 'Gender', options: [{ text: 'Male', value: 'm' }, { text: 'Female', value: 'f' }] },
    { name: 'nextStep', type: 'text', title: 'STAGE' },
    { name: 'amount', type: 'number', title: 'AMOUNT' }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>,
    private commonService: CommonService
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.loadData();
  }

  onRemove() {
    const selectedUsers = this.report.list.filter((_, idx) => this.checked[idx]);
    if (selectedUsers.length) {
      this.service.deleteIncompletedUsers(selectedUsers.map(user => user.clubuserprogramfeeID)).subscribe(
        () => {
          this.commonService.alertMessage({ type: 'success', message: 'Successfully removed users from the fee.' });
          this.loadData();
        },
        () => {
          this.commonService.alertMessage({ type: 'error', message: 'Something went wrong. Please try again later.' });
        }
      );
    }
  }

  onChecked() {
    this.rcheck.emit(this.isChecked);
  }

  loadData() {
    this.pullData('getInCompleteReportReportData');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/incomplete-report/incomplete-report.component.ts